import type { DiscoverFilters } from "~/react/types/discover"

/**
 * Builds URLSearchParams from DiscoverFilters object.
 * Handles arrays, objects (as key lists), and primitive values.
 */
export function buildFilterParams(filters: DiscoverFilters): URLSearchParams {
  const params = new URLSearchParams()

  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null) return

    if (Array.isArray(value)) {
      if (value.length === 0) return
      value.forEach((v) => {
        const strValue = Array.isArray(v) ? String(v[0]) : String(v)
        params.append(`${key}[]`, strValue)
      })
    } else if (typeof value === "object") {
      const keys = Object.keys(value)
      if (keys.length === 0) return
      keys.forEach((k) => params.append(`${key}[]`, k))
    } else {
      params.append(key, String(value))
    }
  })

  return params
}

/**
 * Checks if the filters object has any actual filter values set.
 * Note: last_ai_query is metadata about how filters were generated, not an actual search filter.
 */
export function hasActiveFilters(filters: DiscoverFilters): boolean {
  return Object.keys(filters).some((key) => {
    if (key === "last_ai_query") return false

    const value = filters[key as keyof DiscoverFilters]
    if (value === undefined || value === null) return false
    if (Array.isArray(value) && value.length === 0) return false
    if (typeof value === "object" && Object.keys(value).length === 0) return false
    return true
  })
}
